import type { Admin } from '@gozoki/api-types'
import type { Right } from '@gozoki/tools'
import { createContext } from 'react'

export interface AuthContextType {
  authenticated: boolean
  user: Admin | null
  refetchUser: () => Promise<unknown>
  isLoading: boolean
  logout: () => Promise<void>
  hasRights: (rights: Right[]) => boolean
  hasOneRight: (rights: Right[]) => boolean
}

export const AuthContext = createContext<AuthContextType>({
  authenticated: false,
  hasRights: () => false,
  hasOneRight: () => false,
  isLoading: false,

  logout: async () => {},

  refetchUser: async () => {},
  user: null,
})
